import { render, staticRenderFns } from "./Postgrest.vue?vue&type=template&id=61f4879a&"
import script from "./Postgrest.vue?vue&type=script&lang=ts&"
export * from "./Postgrest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports